(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup-exa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-popup-exa')) {
    class PromoPopupExa extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'disabled';
        this.daysFrequency = parseInt(this.dataset.delayDays, 10) || 30;
        this.secondsDelay = parseInt(this.dataset.delaySeconds, 10) || 0;
        this.closeOnOverlay = this.dataset.closeOnOverlay === 'true';
        this.debugEnabled = this.dataset.debug === 'true' || this.hasDebugParam();
        this.storageKey = 'promo-popup-exa-data-' + window.location.host + '-' + this.dataset.sectionId;
        this.signUpOverlay = this.querySelector('.promo-popup-exa__overlay:not(.promo-popup-exa__overlay--success)');
        this.signUpModal = this.querySelector('.promo-popup-exa__modal:not(.promo-popup-exa__modal--success)');
        this.successOverlay = this.querySelector('.promo-popup-exa__overlay--success');
        this.successModal = this.querySelector('.promo-popup-exa__modal--success');
        this.questions = Array.from(this.querySelectorAll('.promo-popup-exa-question'));
        this.scratchers = Array.from(this.querySelectorAll('.promo-popup-exa-scratcher-block'));
        this.hasScratcherEmail =
          this.dataset.hasScratcherEmail === 'true' ||
          this.scratchers.some((scratcher) => scratcher.querySelector('.promo-popup-exa-scratcher-block__email-form'));
        if (this.hasScratcherEmail) {
          this.dataset.hasScratchers = 'true';
          this.dataset.hasScratcherEmail = 'true';
        }
        this.quizStatus = this.querySelector('.promo-popup-exa__quiz-status');
        this.backButton = this.querySelector('.promo-popup-exa__back');
        this.timer = this.querySelector('.promo-popup-exa__timer');
        this.minutesSpan = this.querySelector('.promo-popup-exa__timer-minutes');
        this.secondsSpan = this.querySelector('.promo-popup-exa__timer-seconds');
        this.boundKeydown = this.handleKeydown.bind(this);
        this.boundBackgroundClick = this.handleBackgroundClick.bind(this);

        this.querySelectorAll('[data-promo-popup-exa-close]').forEach((button) => {
          button.addEventListener('click', this.handleClose.bind(this));
        });

        if (this.signUpModal) this.signUpModal.addEventListener('click', this.boundBackgroundClick);
        if (this.successModal) this.successModal.addEventListener('click', this.boundBackgroundClick);

        this.questions.forEach((question) => {
          question.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.addEventListener('change', () => this.handleQuestionChange(question));
          });
        });

        if (this.backButton) this.backButton.addEventListener('click', () => this.showQuestionStep(true));
        document.addEventListener('keydown', this.boundKeydown);

        this.debug('connected', {
          mode: this.mode,
          questions: this.questions.length,
          scratchers: this.scratchers.length,
          hasScratcherEmail: this.hasScratcherEmail
        });

        if (this.questions.length === 0) {
          if (this.hasScratcherEmail && this.scratchers.length > 0) {
            this.showScratcherStep(false);
          } else {
            this.showEmailStep(false);
          }
        }
        if (this.mode === 'testing') this.openSignUpModal(true);
        if (this.mode === 'success_testing') this.openSuccessModal(false);
        if (this.mode === 'enabled' && this.shouldDisplay()) this.openSignUpModal(false);
      }

      disconnectedCallback() {
        window.clearTimeout(this.openTimer);
        window.clearInterval(this.timerInterval);
        document.removeEventListener('keydown', this.boundKeydown);
        if (this.signUpModal) this.signUpModal.removeEventListener('click', this.boundBackgroundClick);
        if (this.successModal) this.successModal.removeEventListener('click', this.boundBackgroundClick);
      }

      hasDebugParam() {
        try {
          const params = new URLSearchParams(window.location.search);
          return params.has('promo_popup_exa_debug') || params.has('popup_exa_debug');
        } catch (error) {
          return false;
        }
      }

      debug(message, data) {
        if (!this.debugEnabled || !window.console || !window.console.debug) return;
        if (data !== undefined) {
          window.console.debug('[promo-popup-exa]', message, data);
        } else {
          window.console.debug('[promo-popup-exa]', message);
        }
      }

      shouldDisplay() {
        try {
          const stored = window.localStorage.getItem(this.storageKey);
          if (!stored) return true;
          const data = JSON.parse(stored);
          if (!data.next_display_date) return true;
          return new Date().getTime() > new Date(data.next_display_date).getTime();
        } catch (error) {
          return true;
        }
      }

      openSignUpModal(instant) {
        window.clearTimeout(this.openTimer);
        const open = () => {
          this.debug('open signup');
          this.classList.add('is-active');
          if (this.signUpOverlay) this.signUpOverlay.classList.add('is-active');
          if (this.signUpModal) this.signUpModal.classList.add('is-active');
          if (this.getVisibleQuestions().length > 0 && !this.classList.contains('promo-popup-exa--email-step')) {
            this.showQuestionStep(false);
          } else if (this.hasScratcherEmail && this.scratchers.length > 0 && !this.classList.contains('promo-popup-exa--email-step')) {
            this.showScratcherStep(false);
          } else {
            this.showEmailStep(false);
          }
          this.startTimer();
          const closeButton = this.signUpModal ? this.signUpModal.querySelector('.promo-popup-exa__close') : null;
          if (closeButton) closeButton.focus();
        };

        if (instant) {
          open();
          return;
        }
        this.openTimer = window.setTimeout(open, this.secondsDelay * 1000);
      }

      closeSignUpModal(saveDismissed) {
        if (this.signUpOverlay) this.signUpOverlay.classList.remove('is-active');
        if (this.signUpModal) this.signUpModal.classList.remove('is-active');
        this.stopTimer();
        if (saveDismissed) this.markDismissed();
        if (!this.successModal || !this.successModal.classList.contains('is-active')) {
          this.classList.remove('is-active');
        }
      }

      openSuccessModal(saveDismissed) {
        this.closeSignUpModal(false);
        if (saveDismissed) this.markDismissed();
        this.classList.add('is-active');
        if (this.successOverlay) this.successOverlay.classList.add('is-active');
        if (this.successModal) this.successModal.classList.add('is-active');
        const closeButton = this.successModal ? this.successModal.querySelector('.promo-popup-exa__close') : null;
        if (closeButton) closeButton.focus();
      }

      closeSuccessModal() {
        if (this.successOverlay) this.successOverlay.classList.remove('is-active');
        if (this.successModal) this.successModal.classList.remove('is-active');
        this.classList.remove('is-active');
      }

      handleClose(event) {
        const target = event.currentTarget.dataset.promoPopupExaClose;
        if (event.currentTarget.classList.contains('promo-popup-exa__overlay') && !this.closeOnOverlay) return;
        if (target === 'success') {
          this.closeSuccessModal();
        } else {
          this.closeSignUpModal(true);
        }
      }

      handleBackgroundClick(event) {
        if (!this.classList.contains('promo-popup-exa--fullscreen-background')) return;
        if (!this.closeOnOverlay) return;
        if (!event.currentTarget.classList.contains('is-active')) return;
        if (event.target.closest('.promo-popup-exa__content')) return;
        if (event.target.closest('.promo-popup-exa__close')) return;

        if (event.currentTarget.classList.contains('promo-popup-exa__modal--success')) {
          this.closeSuccessModal();
        } else {
          this.closeSignUpModal(true);
        }
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') return;
        if (this.successModal && this.successModal.classList.contains('is-active')) {
          this.closeSuccessModal();
          return;
        }
        if (this.signUpModal && this.signUpModal.classList.contains('is-active')) this.closeSignUpModal(true);
      }

      markDismissed() {
        if (this.mode !== 'enabled') return;
        const nextDisplayDate = new Date();
        nextDisplayDate.setDate(nextDisplayDate.getDate() + this.daysFrequency);
        try {
          window.localStorage.setItem(this.storageKey, JSON.stringify({ next_display_date: nextDisplayDate.toISOString(), dismissed: true }));
        } catch (error) {
        }
      }

      showScratcherStep(focusScratcher) {
        const scratcher = this.scratchers[0] || null;
        this.classList.add('promo-popup-exa--scratcher-step');
        this.classList.remove('promo-popup-exa--email-step');
        this.classList.remove('promo-popup-exa--question-email-step');
        this.classList.remove('promo-popup-exa--scratcher-email-step');
        if (this.quizStatus) this.quizStatus.setAttribute('aria-hidden', 'true');
        this.questions.forEach((question) => question.removeAttribute('data-invalid'));
        this.questions.forEach((question) => question.classList.remove('promo-popup-exa-question--email-step'));
        this.scratchers.forEach((item) => item.classList.remove('promo-popup-exa-scratcher-block--email-step'));
        this.setupScratchers(scratcher || this);
        this.debug('show scratcher step', {
          scratcherId: scratcher ? scratcher.id : null
        });
        if (focusScratcher && scratcher) {
          const scratcherControl = scratcher.querySelector('popup-scratcher-exa');
          if (scratcherControl) scratcherControl.focus();
        }
      }

      showEmailStep(focusEmail, activeQuestion = null) {
        this.classList.add('promo-popup-exa--email-step');
        this.classList.remove('promo-popup-exa--scratcher-step');
        this.classList.remove('promo-popup-exa--question-email-step');
        this.classList.remove('promo-popup-exa--scratcher-email-step');
        if (this.quizStatus) this.quizStatus.setAttribute('aria-hidden', 'true');
        this.questions.forEach((question) => question.removeAttribute('data-invalid'));
        this.questions.forEach((question) => question.classList.remove('promo-popup-exa-question--email-step'));
        this.scratchers.forEach((scratcher) => scratcher.classList.remove('promo-popup-exa-scratcher-block--email-step'));

        const scratcherForEmail = this.hasScratcherEmail ? this.getVisibleScratchers()[0] || this.scratchers[0] || null : null;
        if (scratcherForEmail) {
          this.showScratcherEmailStep(focusEmail, scratcherForEmail);
          return;
        }

        const questionForEmail = activeQuestion || this.getVisibleQuestions()[0] || null;
        if (questionForEmail) questionForEmail.classList.add('promo-popup-exa-question--email-step');
        this.classList.toggle('promo-popup-exa--question-email-step', Boolean(questionForEmail));
        this.setupScratchers();
        this.debug('show email step', {
          owner: questionForEmail ? 'question' : 'global',
          questionId: questionForEmail ? questionForEmail.id : null
        });
        if (focusEmail) window.requestAnimationFrame(() => this.focusEmailInput(questionForEmail || this));
      }

      showScratcherEmailStep(focusEmail, activeScratcher = null) {
        const scratcherForEmail = activeScratcher || this.getVisibleScratchers()[0] || this.scratchers[0] || null;
        this.classList.add('promo-popup-exa--email-step');
        this.classList.remove('promo-popup-exa--scratcher-step');
        this.classList.add('promo-popup-exa--scratcher-email-step');
        this.classList.remove('promo-popup-exa--question-email-step');
        if (this.quizStatus) this.quizStatus.setAttribute('aria-hidden', 'true');
        this.questions.forEach((question) => question.removeAttribute('data-invalid'));
        this.questions.forEach((question) => question.classList.remove('promo-popup-exa-question--email-step'));
        this.scratchers.forEach((scratcher) => scratcher.classList.remove('promo-popup-exa-scratcher-block--email-step'));
        if (scratcherForEmail) scratcherForEmail.classList.add('promo-popup-exa-scratcher-block--email-step');
        this.setupScratchers(scratcherForEmail);
        this.debug('show scratcher email step', {
          scratcherId: scratcherForEmail ? scratcherForEmail.id : null
        });
        if (focusEmail && scratcherForEmail) window.requestAnimationFrame(() => this.focusEmailInput(scratcherForEmail));
      }

      showQuestionStep(focusQuestion) {
        const visibleQuestions = this.getVisibleQuestions();
        if (visibleQuestions.length === 0) return;
        this.classList.remove('promo-popup-exa--email-step');
        this.classList.remove('promo-popup-exa--scratcher-step');
        this.classList.remove('promo-popup-exa--question-email-step');
        this.classList.remove('promo-popup-exa--scratcher-email-step');
        this.questions.forEach((question) => question.classList.remove('promo-popup-exa-question--email-step'));
        this.scratchers.forEach((scratcher) => scratcher.classList.remove('promo-popup-exa-scratcher-block--email-step'));
        if (this.quizStatus) this.quizStatus.removeAttribute('aria-hidden');
        if (focusQuestion) {
          const firstInput = visibleQuestions[0].querySelector('input[type="radio"]');
          if (firstInput) firstInput.focus();
        }
      }

      handleQuestionChange(question) {
        if (!this.isVisible(question)) return;
        question.removeAttribute('data-invalid');
        if (this.validateQuestions(false)) this.showEmailStep(true, question);
      }

      validateQuestions(showError = true) {
        const missing = this.getVisibleQuestions().filter((question) => {
          return question.dataset.required === 'true' && !question.querySelector('input[type="radio"]:checked');
        });

        this.questions.forEach((question) => question.removeAttribute('data-invalid'));
        if (missing.length === 0) return true;

        missing.forEach((question) => question.setAttribute('data-invalid', 'true'));
        if (showError) {
          const firstInput = missing[0].querySelector('input[type="radio"]');
          if (firstInput) firstInput.focus();
        }
        return false;
      }

      getVisibleQuestions() {
        return this.questions.filter((question) => this.isVisible(question));
      }

      getVisibleScratchers() {
        return this.scratchers.filter((scratcher) => this.isVisible(scratcher));
      }

      isVisible(element) {
        if (!element) return false;
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }

      setupScratchers(container = this) {
        window.requestAnimationFrame(() => {
          const scope = container || this;
          scope.querySelectorAll('popup-scratcher-exa').forEach((scratcher) => {
            if (scratcher.setupCanvas) scratcher.setupCanvas();
          });
        });
      }

      focusEmailInput(container = this) {
        const emailInput = container.querySelector('.promo-popup-exa__email-input');
        if (emailInput) emailInput.focus();
      }

      startTimer() {
        if (!this.timer || this.timerInterval) return;
        this.initialTimerSeconds = Math.max(1, Math.round((parseFloat(this.dataset.timerDuration) || 1) * 60));
        this.totalSeconds = this.initialTimerSeconds;
        this.updateTimer();
        this.timerInterval = window.setInterval(() => {
          this.totalSeconds -= 1;
          if (this.totalSeconds <= 0) this.totalSeconds = this.initialTimerSeconds;
          this.updateTimer();
        }, 1000);
      }

      stopTimer() {
        window.clearInterval(this.timerInterval);
        this.timerInterval = null;
      }

      updateTimer() {
        if (!this.minutesSpan || !this.secondsSpan) return;
        const minutes = Math.floor(this.totalSeconds / 60).toString().padStart(2, '0');
        const seconds = Math.floor(this.totalSeconds % 60).toString().padStart(2, '0');
        this.minutesSpan.textContent = minutes;
        this.secondsSpan.textContent = seconds;
      }
    }

    customElements.define('promo-popup-exa', PromoPopupExa);
  }

  if (!customElements.get('popup-scratcher-exa')) {
    class PopupScratcherExa extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('.popup-scratcher-exa__canvas');
        this.popup = this.closest('promo-popup-exa');
        this.ownerBlock = this.closest('.promo-popup-exa-scratcher-block');
        this.form = this.ownerBlock ? this.ownerBlock.querySelector('.promo-popup-exa-scratcher-block__email-form') : null;
        this.forms = this.form ? [this.form] : [];
        this.reward = this.querySelector('.popup-scratcher-exa__reward');
        this.threshold = Math.min(0.9, Math.max(0.3, parseFloat(this.dataset.threshold) || 0.6));
        this.brushSize = Math.min(140, Math.max(24, parseInt(this.dataset.brushSize, 10) || 56));
        this.revealed = this.dataset.startRevealed === 'true';
        this.lockEmail = this.dataset.lockEmail === 'true';
        this.pointerActive = false;
        this.setupAttempts = 0;
        this.boundResize = this.handleResize.bind(this);

        if (this.revealed || !this.canvas || !this.canvas.getContext) {
          this.reveal(false);
          return;
        }

        if (this.reward) this.reward.setAttribute('aria-hidden', 'true');
        if (this.lockEmail) this.lockForm();
        this.setupCanvas();
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.canvas.addEventListener('pointerdown', this.handlePointerDown.bind(this));
        this.canvas.addEventListener('pointermove', this.handlePointerMove.bind(this));
        this.canvas.addEventListener('pointerup', this.handlePointerUp.bind(this));
        this.canvas.addEventListener('pointercancel', this.handlePointerUp.bind(this));
        window.addEventListener('resize', this.boundResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.boundResize);
        window.clearTimeout(this.resizeTimer);
        window.clearTimeout(this.setupRetryTimer);
      }

      lockForm() {
        if (this.forms.length === 0) return;
        this.lockedControls = this.forms.flatMap((form) => {
          return Array.from(form.querySelectorAll('input:not([type="hidden"]), button, select, textarea')).filter((control) => !this.contains(control));
        });
        this.lockedControls.forEach((control) => {
          control.dataset.scratcherWasDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
        });
        if (this.ownerBlock) this.ownerBlock.classList.add('promo-popup-exa-scratcher-block--email-locked');
      }

      unlockForm() {
        if (!this.lockedControls) {
          if (this.ownerBlock) this.ownerBlock.classList.remove('promo-popup-exa-scratcher-block--email-locked');
          return;
        }
        this.lockedControls.forEach((control) => {
          if (control.dataset.scratcherWasDisabled !== 'true') control.disabled = false;
          delete control.dataset.scratcherWasDisabled;
        });
        if (this.ownerBlock) this.ownerBlock.classList.remove('promo-popup-exa-scratcher-block--email-locked');
      }

      setupCanvas() {
        if (this.revealed || !this.canvas) return;
        const width = this.clientWidth;
        const height = this.clientHeight;
        if (!width || !height) {
          this.classList.remove('popup-scratcher-exa--ready');
          window.clearTimeout(this.setupRetryTimer);
          this.setupAttempts += 1;
          this.debug('scratcher canvas waiting for size', {
            scratcherId: this.ownerBlock ? this.ownerBlock.id : null,
            width: width,
            height: height,
            attempt: this.setupAttempts
          });
          if (this.setupAttempts <= 20) this.setupRetryTimer = window.setTimeout(() => this.setupCanvas(), 100);
          return;
        }

        this.setupAttempts = 0;
        const scale = window.devicePixelRatio || 1;
        this.canvas.width = Math.floor(width * scale);
        this.canvas.height = Math.floor(height * scale);
        this.canvas.style.width = width + 'px';
        this.canvas.style.height = height + 'px';
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });
        this.context.setTransform(scale, 0, 0, scale, 0, 0);
        this.context.globalCompositeOperation = 'source-over';
        const overlayColor = this.resolveColor('var(--popup-scratcher-exa-overlay-color)') || '#9a9a9a';
        this.context.fillStyle = overlayColor;
        this.context.fillRect(0, 0, width, height);

        for (let x = -height; x < width; x += 18) {
          this.context.beginPath();
          this.context.moveTo(x, height);
          this.context.lineTo(x + height, 0);
          this.context.strokeStyle = 'rgba(255,255,255,0.18)';
          this.context.lineWidth = 9;
          this.context.stroke();
        }

        this.context.fillStyle = 'rgba(0,0,0,0.1)';
        this.context.fillRect(0, 0, width, height);
        this.context.globalCompositeOperation = 'destination-out';
        this.context.lineCap = 'round';
        this.context.lineJoin = 'round';
        this.context.lineWidth = this.brushSize;
        this.classList.add('popup-scratcher-exa--ready');
        this.debug('scratcher canvas ready', {
          scratcherId: this.ownerBlock ? this.ownerBlock.id : null,
          width: width,
          height: height,
          overlayColor: overlayColor
        });
      }

      debug(message, data) {
        if (this.popup && this.popup.debug) this.popup.debug(message, data);
      }

      resolveColor(value) {
        if (!value) return null;
        const sample = document.createElement('span');
        sample.style.backgroundColor = value;
        sample.style.display = 'none';
        this.appendChild(sample);
        const color = getComputedStyle(sample).backgroundColor;
        sample.remove();
        return color && color !== 'rgba(0, 0, 0, 0)' ? color : null;
      }

      handleResize() {
        if (this.revealed) return;
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.setupCanvas(), 150);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.reveal(true);
      }

      handlePointerDown(event) {
        if (this.revealed || !this.context) return;
        event.preventDefault();
        this.pointerActive = true;
        this.canvas.setPointerCapture(event.pointerId);
        this.lastPoint = this.getPoint(event);
        this.erasePoint(this.lastPoint);
        this.scheduleCompletionCheck();
      }

      handlePointerMove(event) {
        if (!this.pointerActive || this.revealed || !this.context) return;
        event.preventDefault();
        const point = this.getPoint(event);
        this.eraseLine(this.lastPoint, point);
        this.lastPoint = point;
        this.scheduleCompletionCheck();
      }

      handlePointerUp(event) {
        if (!this.pointerActive) return;
        this.pointerActive = false;
        if (this.canvas.hasPointerCapture(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId);
        this.scheduleCompletionCheck();
      }

      getPoint(event) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      }

      erasePoint(point) {
        this.context.beginPath();
        this.context.arc(point.x, point.y, this.context.lineWidth / 2, 0, Math.PI * 2);
        this.context.fill();
      }

      eraseLine(from, to) {
        this.context.beginPath();
        this.context.moveTo(from.x, from.y);
        this.context.lineTo(to.x, to.y);
        this.context.stroke();
      }

      scheduleCompletionCheck() {
        if (this.checkFrame) return;
        this.checkFrame = window.requestAnimationFrame(() => {
          this.checkFrame = null;
          this.checkCompletion();
        });
      }

      checkCompletion() {
        if (!this.context) return;
        const pixels = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
        let cleared = 0;
        for (let index = 3; index < pixels.length; index += 4) {
          if (pixels[index] < 128) cleared += 1;
        }
        if (cleared / (pixels.length / 4) >= this.threshold) this.reveal(true);
      }

      reveal(focusEmail) {
        this.revealed = true;
        this.classList.add('popup-scratcher-exa--revealed');
        this.setAttribute('aria-pressed', 'true');
        if (this.reward) this.reward.removeAttribute('aria-hidden');
        this.unlockForm();
        if (this.popup && this.popup.showScratcherEmailStep && this.ownerBlock) {
          this.popup.showScratcherEmailStep(focusEmail, this.ownerBlock);
        }
        this.debug('scratcher revealed', {
          scratcherId: this.ownerBlock ? this.ownerBlock.id : null
        });
        if (focusEmail && this.form && (!this.popup || !this.popup.showScratcherEmailStep)) {
          const email = this.form.querySelector('input[type="email"]');
          if (email) email.focus();
        }
      }
    }

    customElements.define('popup-scratcher-exa', PopupScratcherExa);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
  if (!customElements.get('popup-scratcher')) {
    class PopupScratcher extends HTMLElement {
      connectedCallback() {
        this.canvas = this.querySelector('.popup-scratcher__canvas');
        this.form = this.closest('form');
        this.formContainer = this.closest('.popup-modal__email-form');
        this.reward = this.querySelector('.popup-scratcher__reward');
        this.threshold = Math.min(0.9, Math.max(0.3, parseFloat(this.dataset.threshold) || 0.6));
        this.revealed = this.dataset.startRevealed === 'true';
        this.pointerActive = false;
        this.boundResize = this.handleResize.bind(this);

        if (this.revealed || !this.canvas || !this.canvas.getContext) {
          this.reveal(false);
          return;
        }

        if (this.reward) this.reward.setAttribute('aria-hidden', 'true');
        this.lockForm();
        this.setupCanvas();
        this.addEventListener('keydown', this.handleKeydown.bind(this));
        this.canvas.addEventListener('pointerdown', this.handlePointerDown.bind(this));
        this.canvas.addEventListener('pointermove', this.handlePointerMove.bind(this));
        this.canvas.addEventListener('pointerup', this.handlePointerUp.bind(this));
        this.canvas.addEventListener('pointercancel', this.handlePointerUp.bind(this));
        window.addEventListener('resize', this.boundResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.boundResize);
      }

      lockForm() {
        if (!this.form) return;
        this.lockedControls = Array.from(this.form.querySelectorAll('input:not([type="hidden"]), button, select, textarea')).filter((control) => !this.contains(control));
        this.lockedControls.forEach((control) => {
          control.dataset.scratcherWasDisabled = control.disabled ? 'true' : 'false';
          control.disabled = true;
        });
        if (this.formContainer) this.formContainer.classList.add('popup-modal__email-form--locked');
      }

      unlockForm() {
        if (!this.lockedControls) return;
        this.lockedControls.forEach((control) => {
          if (control.dataset.scratcherWasDisabled !== 'true') control.disabled = false;
          delete control.dataset.scratcherWasDisabled;
        });
        if (this.formContainer) this.formContainer.classList.remove('popup-modal__email-form--locked');
      }

      setupCanvas() {
        const width = this.clientWidth;
        const height = this.clientHeight;
        if (!width || !height) {
          window.requestAnimationFrame(() => this.setupCanvas());
          return;
        }

        const scale = window.devicePixelRatio || 1;
        this.canvas.width = Math.floor(width * scale);
        this.canvas.height = Math.floor(height * scale);
        this.canvas.style.width = `${width}px`;
        this.canvas.style.height = `${height}px`;
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });
        this.context.setTransform(scale, 0, 0, scale, 0, 0);
        this.context.globalCompositeOperation = 'source-over';
        this.context.fillStyle = this.resolveColor(getComputedStyle(this).getPropertyValue('--popup-scratcher-overlay-color').trim()) || '#9a9a9a';
        this.context.fillRect(0, 0, width, height);

        for (let x = -height; x < width; x += 18) {
          this.context.beginPath();
          this.context.moveTo(x, height);
          this.context.lineTo(x + height, 0);
          this.context.strokeStyle = 'rgba(255,255,255,0.18)';
          this.context.lineWidth = 9;
          this.context.stroke();
        }

        this.context.fillStyle = 'rgba(0,0,0,0.1)';
        this.context.fillRect(0, 0, width, height);
        this.context.globalCompositeOperation = 'destination-out';
        this.context.lineCap = 'round';
        this.context.lineJoin = 'round';
        this.context.lineWidth = Math.max(24, Math.min(width, height) * 0.2);
        this.classList.add('popup-scratcher--ready');
      }

      resolveColor(value) {
        if (!value) return null;
        const sample = document.createElement('span');
        sample.style.backgroundColor = value;
        sample.style.display = 'none';
        this.appendChild(sample);
        const color = getComputedStyle(sample).backgroundColor;
        sample.remove();
        return color && color !== 'rgba(0, 0, 0, 0)' ? color : value;
      }

      handleResize() {
        if (this.revealed) return;
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.setupCanvas(), 150);
      }

      handleKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.reveal(true);
      }

      handlePointerDown(event) {
        if (this.revealed) return;
        event.preventDefault();
        this.pointerActive = true;
        this.canvas.setPointerCapture(event.pointerId);
        this.lastPoint = this.getPoint(event);
        this.erasePoint(this.lastPoint);
        this.scheduleCompletionCheck();
      }

      handlePointerMove(event) {
        if (!this.pointerActive || this.revealed) return;
        event.preventDefault();
        const point = this.getPoint(event);
        this.eraseLine(this.lastPoint, point);
        this.lastPoint = point;
        this.scheduleCompletionCheck();
      }

      handlePointerUp(event) {
        if (!this.pointerActive) return;
        this.pointerActive = false;
        if (this.canvas.hasPointerCapture(event.pointerId)) this.canvas.releasePointerCapture(event.pointerId);
        this.scheduleCompletionCheck();
      }

      getPoint(event) {
        const rect = this.canvas.getBoundingClientRect();
        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      }

      erasePoint(point) {
        this.context.beginPath();
        this.context.arc(point.x, point.y, this.context.lineWidth / 2, 0, Math.PI * 2);
        this.context.fill();
      }

      eraseLine(from, to) {
        this.context.beginPath();
        this.context.moveTo(from.x, from.y);
        this.context.lineTo(to.x, to.y);
        this.context.stroke();
      }

      scheduleCompletionCheck() {
        if (this.checkFrame) return;
        this.checkFrame = window.requestAnimationFrame(() => {
          this.checkFrame = null;
          this.checkCompletion();
        });
      }

      checkCompletion() {
        const pixels = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height).data;
        let cleared = 0;
        for (let index = 3; index < pixels.length; index += 4) {
          if (pixels[index] < 128) cleared += 1;
        }

        if (cleared / (pixels.length / 4) >= this.threshold) this.reveal(true);
      }

      reveal(focusEmail) {
        this.revealed = true;
        this.classList.add('popup-scratcher--revealed');
        this.setAttribute('aria-pressed', 'true');
        if (this.reward) this.reward.removeAttribute('aria-hidden');
        this.unlockForm();
        if (focusEmail && this.form) {
          const email = this.form.querySelector('input[type="email"]');
          if (email) email.focus();
        }
      }
    }

    customElements.define('popup-scratcher', PopupScratcher);
  }

  } catch(e) { console.error(e); }
})();
})();
